module.exports = __webpack_public_path__ + "img/health-telemedicina-bg.35d97e72.png";